import { createContext } from 'react';

import { PerguntaResponse } from 'api/Associado/duvidas';

import { Perguntas } from './reducer';

export interface WSChanges {
  idDuvidaFrequente: number;
  usuarioDuvida: string;
  duvida: string;
  resposta: string | null;
  lido?: boolean;
}

interface DuvidasFrequentesContext {
  list: () => void;
  ask: () => void;
  answer: (idDuvida: number, publica?: boolean) => void;
  perguntas: Perguntas | null;
  perguntaAtual: PerguntaResponse | null;
  tab: 0 | 1;
  changeTab: (tab: 0 | 1) => void;
  atualizarPergunta: (changes: PerguntaResponse) => void;
  cpf: string;
}

export default createContext<DuvidasFrequentesContext>({
  list: () => ({}),
  ask: () => ({}),
  answer: () => ({}),
  perguntas: null,
  perguntaAtual: null,
  tab: 0,
  changeTab: () => ({}),
  atualizarPergunta: () => ({}),
  cpf: '',
});
